import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "agent-yearly-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./AgentYearlyReport.html",
})
export class AgentYearlyReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  finyearList = [];
  seasonList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  exceldata: any;
  filter = {
    season_id: 0,
    fin_id: 3,
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: [],
  };
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  seasonCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.loadSeasonList();
    this.LoadFinYearList();
    this.columns = [
      {
        name: "S.No",
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        prop: "sno",
        type: "sno",
        //cellTemplate: this.snoTemplate,
        toggle: true,
      },
      {
        name: "Name",
        width: 300,
        minWidth: 300,
        maxWidth: 300,
        prop: "agent_name",
      },
      {
        name: "Order Target",
        width: 150,
        minWidth: 150,
        maxWidth: 150,
        summary: "sum",
        prop: "order_target",
        cellClass: "txtRight",
      },
      {
        name: "Order Qty",
        summary: "sum",
        width: 150,
        minWidth: 150,
        maxWidth: 150,
        prop: "order_qty",
        cellClass: "txtRight",
      },
      {
        name: "Diff",
        width: 150,
        summary: "sum",
        minWidth: 150,
        maxWidth: 150,
        prop: "order_diff",
        cellClass: "txtRight",
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentYearlyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      //this.getAgentYearlyReport();
      let fin = res.data[0];
      this.filterData.fin_id = fin["fin_id"];
      this.finyearCtrl.setValue(fin["fin_id"]);
      this.applyFilter();
    });
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentYearlyReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentYearlyReport();
  }

  getAgentYearlyReport(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      season_id: this.filter.season_id,
      fin_id: this.filter.fin_id,
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getAgentYearlyReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        //that.dataList = res.data;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(res.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Agent Yearly report",
          columns: that.gridOptions.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  clearFilter(): void {
    this.filterData = {
      name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getAgentYearlyReport();
  }

  displayFn(season: number) {
    let list: any[];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_id = id;
      return fitem["season_name"];
    }
    return "";
  }

  finyearFn(season: number) {
    let list: any = [];
    let that = this;
    list = this.finyearList;

    let id = season && season ? season : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });

      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }

  loadSeasonList() {
    let that = this;
    that.reportService.getNewSeasonList(this.filter).then(function (res) {
      that.seasonList = res;
    });
  }

  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    data["fin_id"] = this.filter.fin_id;
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySalesOrderReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/AgentYearlyReport/AgentYearlyReport.ts